import { jsx } from "@emotion/react/jsx-runtime";
import { useTheme } from "@emotion/react";
import { useThemeProps } from "@wsui/base";
import postsModuleContext from "./postsModuleContext.mjs";
import { useContext } from "react";
import PostCardController from "./PostCardController.mjs";
function PostsModuleCardItem(props) {
  useTheme();
  props = useThemeProps({
    props,
    name: "MunicipioPostsModuleCardItem"
  });
  let {
    item,
    visibleFields,
    ...restProps
  } = props;
  if (Array.isArray(visibleFields)) {
    visibleFields = visibleFields.reduce((acc, field) => {
      acc[field] = true;
      return acc;
    }, {});
  }
  let link = item.link;
  let cta = (link == null ? void 0 : link.title) ? link : null;
  link = cta ? null : link;
  const {
    itemColor
  } = useContext(postsModuleContext);
  let post = {
    ...item,
    postType: item.contentType,
    link,
    cta
  };
  return /* @__PURE__ */jsx(PostCardController, {
    post,
    visibleFields,
    color: !item.color || item.color === "auto" ? itemColor : item.color,
    ...restProps
  });
}
export { PostsModuleCardItem as default };